export const EXSBINVOICE_DELETE_RESET = 'EXSBINVOICE_DELETE_RESET'
export const EXSBINVOICE_DELETE_SET_ERROR = 'EXSBINVOICE_DELETE_SET_ERROR'
export const EXSBINVOICE_DELETE_SET_DELETED = 'EXSBINVOICE_DELETE_SET_DELETED'
export const EXSBINVOICE_DELETE_TOGGLE_LOADING = 'EXSBINVOICE_DELETE_TOGGLE_LOADING'
